<template lang="pug">
.select-technician
    div
      //- BOTON INFORME REVISADO (DAR SALIDA)
      //-Da salida a un equipo listo para entregar
      button.change-button(
        :disabled="disabled || loading"
        title="Dar salida"
        @click="handleShowModal")
        | {{ buttonLabel }}
        b-spinner(v-if="loading" class="ml-2" variant="white" small)
      
      SamtekModal(
        v-model="showModalDespacho" 
        title="Ingresar datos de despacho"
        confirmText="Guardar"
        cancelText="Cancelar"
        :loading="loading"
        @confirm="darSalida"
        @cancel="hideModal"
        @shown="onModalShown"
        @hide="onModalHide"
      )
        b-form-group.input-label(
          label="¿Se ha pagado el presupuesto de diagnostico?"
          label-for="",
          v-if="!requiereDistribuidor && tipo_servicio_ot === 4 && otConOvRechazada"
        )
          b-form-radio-group(
              id="radio-pago-presupuesto"
              v-model="pago_presupuesto"
              :options="[{ value: true, text: 'Sí' },{ value: false, text: 'No' }]"
            )
        b-form-group.input-label(label="Tipo de despacho" label-for="input-tipo-despacho")
          b-form-select(
            id="input-tipo-despacho"
            v-model="tipo_despacho"
            :disabled="blockedDespacho"
            :options="tipoDespachoOptions"
            :state="$v.$dirty ? !$v.tipo_despacho.$invalid : null")
          .errors(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.tipo_despacho.required") Campo requerido
        div(v-if="isTipoDespachoEnvio && !requiereDistribuidor")
          b-form-group(label="N° de courier" label-for="input-courier")
            b-input(
              v-model="numero_courrier"
              id="input-courier"
              :state="$v.$dirty ? !$v.numero_courrier.$invalid : null")
            .errors(v-if="$v.numero_courrier.$dirty")
              b-form-invalid-feedback(:state="$v.numero_courrier.required") Campo requerido
          b-form-group(label="Empresa de Courier" label-for="input-courier")
            b-form-select(
              id="input-courier"
              :options="optionsCourier"
              v-model="courier"
              :state="$v.$dirty ? !$v.numero_courrier.$invalid : null")
            .errors(v-if="$v.courier.$dirty")
              b-form-invalid-feedback(:state="$v.courier.required") Campo requerido
        div(v-if="requiereDistribuidor")
          b-form-group(label="Distribuidor" label-for="input-courier")
              b-form-select(
                id="input-courier"
                :options="optionsDistribuidores"
                v-model="distribuidor")
          b-form-group(label="N° de guía de despacho o N° de factura" label-for="input-guia-despacho")
            b-input(
              id="input-guia-despacho"
              v-model="numero_guia_despacho"
              :state="$v.$dirty ? !$v.numero_guia_despacho.$invalid : null")
            .errors(v-if="$v.numero_guia_despacho.$dirty")
              b-form-invalid-feedback(:state="$v.numero_guia_despacho.required") Campo requerido
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'
import SamtekModal from '@/components/Common/SamtekModal.vue'

export default {
  name: 'ActionDarSalida',
  mixins: [LoadingButtonMixin],
  components: {
    SamtekModal,
  },
  props: ['ot', 'disabled', 'toast'],

  validations: {
    tipo_despacho: {
      required: requiredIf(function fn() {
        return !this.requiereDistribuidor
      }),
    },
    numero_courrier: {
      required: requiredIf(function fn() {
        return this.isTipoDespachoEnvio && !this.requiereDistribuidor
      }),
    },
    courier: {
      required: requiredIf(function fn() {
        return this.isTipoDespachoEnvio && !this.requiereDistribuidor
      }),
    },
    numero_guia_despacho: {
      required: requiredIf(function fn() {
        return this.requiereDistribuidor
      }),
    },
  },
  data() {
    return {
      courier: null,
      distribuidor: null,
      show: false,
      user: null,
      showModalDespacho: false,
      tipo_despacho: null,
      blockedDespacho: false,
      numero_guia_despacho: null,
      numero_courrier: null,
      searching: false,
      form: {
        rma: null,
        encargado: null,
      },
      usuarios: [],
      disabledSave: false,
      pago_presupuesto: false,
      tipo_servicio_ot: null,
    }
  },
  methods: {
    ...mapActions('Warehouse', ['changeWarehouseState']),
    ...mapActions('OTStore', [
      'entregaFinal',
      'getOT',
      'getCourier',
      'getDistribuidores',
    ]),
    ...mapActions('AuthenticationStore', ['getAllUsers']),

    handleShowModal() {
      this.startLoading()
      this.showModal()
      this.getCourier()
      this.getDistribuidores()
    },
    onModalShown() {
      this.stopLoading()
    },
    onModalHide() {
      this.stopLoading()
    },
    hideModal() {
      this.state = null
      this.showModalDespacho = false
    },
    showModal() {
      this.tipo_servicio_ot = this.ot.tipo_servicio.id
      if (!this.ot) return false
      const despachos = {
        RETIRO: 3,
        ENVIO: 4,
        COORD_CLIENTE: 7,
        null: null,
      }
      this.tipo_despacho =
        despachos[this.ot?.despacho || this.ot?.sucursal?.despacho]
      // Se manda el valor que la OT ya tenga, no null: entrega_final lo asigna
      // sin condicion, asi que mandar null en una segunda salida borraria el
      // folio que la emision anterior dejo escrito.
      this.numero_guia_despacho = this.ot?.numero_guia_despacho || null
      if (this.tipo_despacho === 7) this.blockedDespacho = true
      this.showModalDespacho = true
    },
    async darSalida() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }

      // Abrir ventana en blanco ANTES del await para evitar pop-up blocker
      let printWindow = null
      if (this.tipo_despacho !== 7 && !this.requiereDistribuidor) {
        printWindow = window.open('', '_blank')
      }

      try {
        await this.executeWithLoading(
          async () => {
            this.disabledSave = true
            const data = {
              ot: this.ot.ot,
              tipo_salida: this.tipo_despacho,
              entregado_por: this.user.id,
              numero_guia_despacho: this.numero_guia_despacho,
              numero_courrier: this.numero_courrier,
              courier: this.courier,
              distribuidor: this.distribuidor,
            }
            const resp = await this.entregaFinal(data)
            if (resp.status === 200) {
              const { mensaje, guia_despacho_url } = resp.data
              this.toast(`OT cerrada (${mensaje})`, {
                variant: 'success',
              })

              // Imprimir guía de despacho si existe (mismo origen -> el navegador
              // permite invocar print()). Se usa un iframe porque el onload de una
              // ventana que navega a un PDF no es confiable.
              if (guia_despacho_url && printWindow) {
                printWindow.document.write(
                  `<!doctype html><html><head><title>Guia de Despacho</title></head>
<body style="margin:0">
<iframe id="gd-print" src="${guia_despacho_url}" style="border:0;width:100%;height:100vh"></iframe>
</body></html>`
                )
                printWindow.document.close()
                const frame = printWindow.document.getElementById('gd-print')
                frame.addEventListener('load', () => {
                  setTimeout(() => {
                    try {
                      frame.contentWindow.focus()
                      frame.contentWindow.print()
                    } catch (e) {
                      printWindow.focus()
                      printWindow.print()
                    }
                  }, 300)
                })
              } else if (printWindow) {
                printWindow.close()
              }

              this.hideModal()
              this.$emit('changed')
              this.$router.push(`/orden/${this.ot.ot}`)
            } else {
              if (printWindow) printWindow.close()
              this.toast(`Error al dar salida (${resp.data})`, {
                variant: 'danger',
              })
            }
            this.show = false
            this.disabledSave = false
          },
          { delay: 500 }
        ) // Delay más largo para operación crítica
      } catch (error) {
        console.error('Error al dar salida:', error)
        if (printWindow) printWindow.close()
        this.toast('Error al procesar salida', {
          variant: 'danger',
        })
        this.disabledSave = false
      }
    },
  },
  created() {
    const { user } = JSON.parse(localStorage.getItem('user'))
    this.user = user
  },
  computed: {
    ...mapGetters('OTStore', ['couriers', 'distribuidores']),
    otConOvRechazada() {
      return (
        this.ot?.datos_ov_asociada?.estado === 'Oportunidad Rechazada' ||
        this.ot?.datos_ov_asociada?.estado === 'Oportunidad Cerrada Rechazada'
      )
    },
    buttonLabel() {
      if (
        this.ot?.sucursal?.despacho === 'ENVIO' ||
        this.ot.despacho === 'ENVIO'
      ) {
        return 'Enviar a cliente'
      }
      return `Dar salida  ${this.salidaAdministrativo ? ' Administrativo' : ''}`
    },
    salidaAdministrativo() {
      return (
        this.user.groups.map((g) => g.name).includes('Administrativo') &&
        this.ot.ubicacion === 'Recepción' &&
        this.ot.cliente?.tipo_cliente === 'Persona'
      )
    },
    tipoDespachoOptions() {
      return [
        { value: null, text: 'Seleccionar...' },
        { value: 3, text: 'Retiro por cliente' },
        { value: 4, text: 'Envío' },
        { value: 7, text: 'Coordinado por cliente' },
      ]
    },
    optionsCourier() {
      return this.couriers
        .map((c) => ({
          value: c.id,
          text: c.nombre,
        }))
        .concat([
          {
            value: null,
            text: 'Seleccione...',
          },
        ])
    },
    optionsDistribuidores() {
      return this.distribuidores
        .map((c) => ({
          value: c.id,
          text: c.nombre,
        }))
        .concat([
          {
            value: null,
            text: 'Seleccione...',
          },
        ])
    },
    requiereDistribuidor() {
      return this.ot.cambio_3x3
    },
    isTipoDespachoEnvio() {
      return this.tipo_despacho === 4 || this.tipo_despacho === 7
    },
  },
}
</script>

<style lang="scss" scoped>
// .change-button {
//   color: #fff;
//   background-color: #5B73E8;
//   border-color: #5B73E8;
//   width: 40px;
//   height: 40px;
//   border-radius: 5px;
//   font-weight: 600;
//   margin: 1px;
//   &:disabled {
//     background-color: #7d93ff;
//     border-color: #7d93ff;
//     cursor: not-allowed;
//   }
// }
// .button {
//   color: #fff;
//   background-color: #5B73E8;
//   border-color: #5B73E8;
//   width: auto;
//   height: 40px;
//   border-radius: 5px;
//   font-weight: 600;
//   font-size: 12px;
//   &:disabled {
//     background-color: #7d93ff;
//     border-color: #7d93ff;
//     cursor: not-allowed;
//   }
// }
</style>
